import { Component, Element, h, Host, Prop } from "@stencil/core";

import { ShareService } from "../../../index";
// import { hasSlot } from "../../utils/utils";
import { StzhPagebottomLocalizedText } from "./stzh-pagebottom.localization";

/**
 * @slot sticky-actions - Slot for sticky actions
 */
@Component({
  tag: "stzh-pagebottom",
  styleUrl: "stzh-pagebottom.scss",
  scoped: true,
})
export class StzhPagebottom {
  /**  Translation strings. */
  @Prop() localization: StzhPagebottomLocalizedText;

  /** Share Title */
  @Prop() shareTitle: string = "";

  /** URL of current site (uses full URL by default) */
  @Prop() shareUrl: string;

  /**
   * Array of enabled share buttons.
   * Possible services: `facebook` / `twitter` / `linkedin` / `xing` / `mail`
   */
  @Prop() shareServices: ShareService[] | string;

  /** Whether to show share */
  @Prop({ reflect: true }) shareDisabled: boolean;

  /** Overwrite share mail subject translation */
  @Prop() shareMailSubject: string;

  /** Overwrite share mail body translation */
  @Prop() shareMailBody: string;

  /** Logo href */
  @Prop() logoHref: string = "https://www.stadt-zuerich.ch";

  /** Whether to show print button */
  @Prop({ reflect: true }) withPrint: boolean;

  /**
   * For Adobe Analytics.
   * Will be rendered as value of `s-object-id` attribute of the print button element.
   */
  @Prop() printAnalyticsId: string;

  /**
   * For Adobe Analytics.
   * Will be rendered as value of `s-object-id` attribute to the logo link element.
   * Default value will be "Footer Logo"
   */
  // @Prop() logoAnalyticsId: string;

  @Element() element: HTMLStzhPagebottomElement;

  async componentWillLoad() {
    if (!this.localization) {
      this.localization = await window.stzhComponents.utils.fetchTranslations(this.element, "pagebottom");
    }
  }

  render() {
    // const printUsed: boolean = hasSlot(this.element, "print");
    // const logoUsed: boolean = hasSlot(this.element, "logo");

    const classes = {
      "stzh-pagebottom": true,
      rs_skip: true, // will prevent component being read by readspeaker
    };

    return (
      <Host>
        <div class={classes}>
          <div class="stzh-pagebottom__wrapper">
            <div class="stzh-pagebottom__left">
              {this.withPrint && (
                <div class="stzh-pagebottom__print">
                  <stzh-print>
                    <stzh-button
                      label={this.localization.printLabel}
                      variant="tertiary-plain"
                      size="small"
                      noPaddingLeft={true}
                      noPaddingRight={true}
                      analyticsId={this.printAnalyticsId}
                    ></stzh-button>
                  </stzh-print>
                </div>
              )}

              {!this.shareDisabled && (
                <div class="stzh-pagebottom__share-wrapper">
                  {this.shareTitle && <div class="stzh-pagebottom__share-title">{this.shareTitle}</div>}
                  <stzh-share
                    url={this.shareUrl}
                    services={this.shareServices}
                    mailSubject={this.shareMailSubject}
                    mailBody={this.shareMailBody}
                  ></stzh-share>
                </div>
              )}
            </div>

            <div class="stzh-pagebottom__sticky-actions">
              <slot name="sticky-actions"></slot>
            </div>
          </div>

          {/* {logoUsed &&
            <div class="stzh-pagebottom__logo">
              <a
                href={this.logoHref}
                class="stzh-pagebottom__logo-link"
                s-object-id={this.logoAnalyticsId || "Footer Logo"}
              >
                <slot name="logo"></slot>
              </a>
            </div>
          } */}
        </div>
      </Host>
    );
  }
}
